import { useAppFlags } from '$launchdarkly/useAppFlags';
import { Global } from '@emotion/react';

export const GlobalStyles = () => {
  const { txmSideNavigation } = useAppFlags();
  return (
    <Global
      // NOTE: Next 16+ requires fonts loaded in pages router to be loaded via link
      // so we refer to the font family of Inter by name (instead of var)
      styles={{
        ':root': {
          fontFamily: `'Inter', open-sans, Helvetica Neue, Helvetica, Arial, sans-serif`,
          '--side-font-family': `'Inter', open-sans, Helvetica Neue, Helvetica, Arial, sans-serif`,
        },
        '@supports (font-variation-settings: normal)': {
          ':root': {
            '--side-font-family': `'Inter', open-sans, Helvetica Neue, Helvetica,
            Arial, sans-serif`,
          },
        },
        ...(txmSideNavigation && {
          // Hide the zendesk unread messages indicator, since we build our own indicator in the side nav
          'iframe[title="Number of unread messages"]': {
            display: 'none !important',
          },
        }),
      }}
    />
  );
};
